@if (score?.currentlyServing) {
    <div class="column serving">
        <div class="cell">
            @if (score?.currentlyServing === 1) {
                <span class="serving-indicator"></span>
            }
        </div>
        <div class="cell">
            @if (score?.currentlyServing === 2) {
                <span class="serving-indicator"></span>
            }
        </div>
    </div>
}
@if (points) {
    <div class="column divider">
        <div class="cell">
            <div [msValueSlider]="points.participant1.toString()"></div>
        </div>
        <div class="cell">
            <div [msValueSlider]="points.participant2.toString()"></div>
        </div>
        @if (!hideScoreBoardColumnFooter) {
            <div class="cell">{{ scoreboardP }}</div>
        }
    </div>
}
@if (frames) {
    <div class="column sets">
        <div class="cell">
            <div [msValueSlider]="frames.participant1.toString()"></div>
        </div>
        <div class="cell">
            <div [msValueSlider]="frames.participant2.toString()"></div>
        </div>
        @if (!hideScoreBoardColumnFooter) {
            <div class="cell">{{ scoreboardF }}</div>
        }
    </div>
}
